import axios from 'axios';
import getTokenForCarSharing from './getTokenForCarSharing';

const carSharingClient = axios.create();

carSharingClient.interceptors.request.use(
  async config => {
    const token = await getTokenForCarSharing();

    if (!token) {
      throw new Error('Failed to get token');
    }

    if (!config.headers) {
      config.headers = {};
    }

    config.headers['X-Auth-Token'] = token;
    config.headers['api-version'] = '1';

    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

export default carSharingClient;
